import { Box, Typography } from "@material-ui/core";
import { get } from "lodash";
import React, { Fragment, useEffect, useState } from "react";
import { VIDEOPROVIDERS } from "src/constants";
import { defaultAttachmentImage } from "src/utils";
import { useStyles } from "../styles";
import { displayAttachments } from "../utils/displayAttachments";
import { usePreviewLink } from "Hooks/checkin/usePreviewLink";
import DisplayWebLink from "Components/PreviewLink/DisplayWebLink";
import { displayLinkState } from "Recoil/Checkins/atom";
import { useRecoilValue } from "recoil";
import Skeleton from "react-loading-skeleton";

export const MultimediaDisplay = ({ checkinDetails, isDashboard }) => {
  const classes = useStyles();
  const [attachmentList, setAttachmentList] = useState();
  const {
    multimediaCheckin: multimedia,
    linkCheckin,
    surveyMultimediaCheckin,
    surveyLinks,
    checkInType,
  } = checkinDetails;

  const viewDetails = useRecoilValue(displayLinkState);
  const { getLinkDetails } = usePreviewLink();
  const type = get(multimedia, "s3Link.fileName", "")
    ? defaultAttachmentImage(
        get(multimedia, "s3Link.key", ""),
        get(multimedia, "s3Link", "")
      )
    : defaultAttachmentImage(linkCheckin?.link, linkCheckin?.link);

  const isVideoProvider = VIDEOPROVIDERS.find(
    (i) =>
      typeof linkCheckin?.link === "string" && linkCheckin?.link.includes(i)
  );

  useEffect(() => {
    if (["SURVEY", "REQUESTFEEDBACK"].includes(checkInType)) {
      const data = [];
      if (surveyLinks?.length > 0) {
        surveyLinks.map((item) => {
          data.push(item);
        });
      }
      if (surveyMultimediaCheckin?.length > 0) {
        surveyMultimediaCheckin?.map((res) => {
          data.push(res.s3Link);
        });
      }
      setAttachmentList(data);
    }
  }, [surveyLinks, surveyMultimediaCheckin]);

  useEffect(() => {
    if (
      !isVideoProvider &&
      typeof linkCheckin?.link === "string" &&
      viewDetails?.url !== linkCheckin?.link
    ) {
      getLinkDetails(linkCheckin?.link);
    }
  }, [linkCheckin?.link]);

  return (
    <Fragment>
      <Fragment>
        {!isVideoProvider && viewDetails?.loading ? (
          <Skeleton height="250px" />
        ) : !isVideoProvider &&
          viewDetails?.image &&
          ["LEARNING"].includes(checkInType) ? (
          <>
            {["LEARNING"].includes(checkInType) && !isDashboard && (
              <Typography
                variant="body2"
                className="font-bold attachment-label"
              >
                Learning content
              </Typography>
            )}
            <Box
              mt={1}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              className="multimedia-box"
            >
              <DisplayWebLink
                url={linkCheckin?.link}
                viewDetails={viewDetails}
                isDashboard={isDashboard}
              />
            </Box>
          </>
        ) : (
          <Box mt={1} className="multimedia-box">
            {["LEARNING"].includes(checkInType) && !isDashboard && (
              <Typography
                variant="body2"
                className="font-bold attachment-label"
                gutterBottom
              >
                Learning content
              </Typography>
            )}
            {attachmentList?.length > 0
              ? displayAttachments(
                  classes,
                  type,
                  attachmentList,
                  isDashboard,
                  true
                )
              : linkCheckin || multimedia
              ? displayAttachments(
                  classes,
                  type,
                  linkCheckin?.link
                    ? linkCheckin?.link
                    : get(multimedia, "s3Link", ""),
                  isDashboard
                )
              : null}
          </Box>
        )}
      </Fragment>
      {/* )} */}
    </Fragment>
  );
};
